unit Auth.Service;

interface

uses
  SysUtils, Web, JS,
  XData.Web.Client, UUtils, UWeb.Enum, System.TypInfo;

type
  TOnLoginSuccess = reference to procedure;
  TOnLoginError = reference to procedure(AMsg: string);

  TAuthService = class
  private
    FClient: TXDataWebClient;
    procedure SetToken(AToken: string);
    procedure DeleteToken;
  public
    constructor Create; reintroduce;
    destructor Destroy; override;
    procedure Login(AUser, APassword: string; ASuccess: TOnLoginSuccess;
      AError: TOnLoginError);
    procedure Logout;
    function GetToken: string;
    function Authenticated: Boolean;
    function TokenExpirationDate(pToken: string = ''): TDateTime;
    function TokenExpired: Boolean;
    function TokenPayload: JS.TJSObject;
    function TokenInvalidoSistema : Boolean;
  end;

  TJwtHelper = class
  private
    class function HasExpirationDate(AToken: string): Boolean;
  public
    class function TokenExpirationDate(AToken: string): TJSDate;
    class function TokenExpired(AToken: string): Boolean;
    class function DecodePayload(AToken: string): string;
    class function IsTokenInvalidoSistema(AToken: string): Boolean;
  end;

  function AuthService: TAuthService;

implementation

uses
  ConnectionModule;

var
  _AuthService: TAuthService;

function AuthService: TAuthService;
begin
  if not Assigned(_AuthService) then
  begin
    _AuthService := TAuthService.Create;
  end;
  Result := _AuthService;
end;

{ TAuthService }

function TAuthService.Authenticated: Boolean;
var
  lTokenNome : string;
begin
  lTokenNome := TUtils.GetTokenNome(DMConnection.FServidor);

  Result := not isNull(window.localStorage.getItem(lTokenNome)) and
            (window.localStorage.getItem(lTokenNome) <> '');
end;

constructor TAuthService.Create;
begin
  FClient := TXDataWebClient.Create(nil);
  FClient.Connection := DMConnection.AuthConnection;
end;

procedure TAuthService.DeleteToken;
var
  lTokenNome : string;
begin
  lTokenNome := TUtils.GetTokenNome(DMConnection.FServidor);
  window.localStorage.removeItem(lTokenNome);
end;

destructor TAuthService.Destroy;
begin
  FClient.Free;
  inherited;
end;

function TAuthService.GetToken: string;
var
  lTokenNome : string;
begin
  lTokenNome := TUtils.GetTokenNome(DMConnection.FServidor);
  Result := window.localStorage.getItem(lTokenNome);
end;

procedure TAuthService.Login(AUser, APassword: string; ASuccess: TOnLoginSuccess;
  AError: TOnLoginError);

  procedure OnLoad(Response: TXDataClientResponse);
  var
    Token: JS.TJSObject;
  begin
    Token := JS.TJSObject(Response.Result);
    SetToken(JS.toString(Token.Properties['value']));
    ASuccess;
  end;

  procedure OnError(Error: TXDataClientError);
  begin
    AError(Format('%s: %s', [Error.ErrorCode, Error.ErrorMessage]));
  end;

begin
  FClient.RawInvoke(
    'ILoginService.Login', [AUser, APassword],
    @OnLoad, @OnError
  );
end;

procedure TAuthService.Logout;
begin
  DeleteToken;
end;

procedure TAuthService.SetToken(AToken: string);
var
  lTokenNome : string;
begin
  lTokenNome := TUtils.GetTokenNome(DMConnection.FServidor);
  window.localStorage.setItem(lTokenNome, AToken);
end;

function TAuthService.TokenExpirationDate(pToken: string): TDateTime;
var
  ExpirationDate: TJSDate;
  lToken : string;
begin
  if not Authenticated then
    Exit(Now);

  lToken := pToken;

  if lToken.IsEmpty then
    lToken := GetToken;

  ExpirationDate := TJwtHelper.TokenExpirationDate(lToken);

  Result := EncodeDate(
              ExpirationDate.FullYear,
              ExpirationDate.Month + 1,
              ExpirationDate.Date
            ) +
            EncodeTime(
              ExpirationDate.Hours,
              ExpirationDate.Minutes,
              ExpirationDate.Seconds,
              0
            );
end;

function TAuthService.TokenExpired: Boolean;
begin
  if not Authenticated then
    Exit(False);
  Result := TJwtHelper.TokenExpired(GetToken);
end;

function TAuthService.TokenInvalidoSistema: Boolean;
begin
  Result := TJwtHelper.IsTokenInvalidoSistema(GetToken);
end;

function TAuthService.TokenPayload: JS.TJSObject;
begin
  if not Authenticated then
    Exit(nil);
  Result := TJSObject(TJSJSON.parse(TJwtHelper.DecodePayload(GetToken)));
end;

{ TJwtHelper }

class function TJwtHelper.DecodePayload(AToken: string): string;
begin
  if Trim(AToken) = '' then
    Exit('');
  Result := '';
  asm
    var Token = AToken.split('.');
    if (Token.length = 3) {
      Result = Token[1];
      Result = atob(Result);
    }
  end;
end;

class function TJwtHelper.HasExpirationDate(AToken: string): Boolean;
var
  Payload: string;
  Obj: TJSObject;
begin
  Payload := DecodePayload(AToken);
  Obj := TJSObject(TJSJSON.parse(Payload));
  Result := Obj.hasOwnProperty('exp');
end;

class function TJwtHelper.IsTokenInvalidoSistema(AToken: string): Boolean;
var
  Payload,
  lNome: string;
  Obj: TJSObject;
begin
  Payload := DecodePayload(AToken);
  Obj := TJSObject(TJSJSON.parse(Payload));

  lNome := GetEnumName(TypeInfo(TServidor), Ord(DMConnection.FServidor)).ToLower;

  if not Obj.hasOwnProperty(lNome) then
  begin
    Result := True;
    Exit;
  end;

  Result := Obj.hasOwnProperty('token_longa_duracao');
end;

class function TJwtHelper.TokenExpirationDate(AToken: string): TJSDate;
var
  Payload: string;
  Obj: TJSObject;
  Epoch: NativeInt;
begin
  if not HasExpirationDate(AToken) then
    raise Exception.Create('Token has not expiration date');

  Payload := DecodePayload(AToken);
  Obj := TJSObject(TJSJSON.parse(Payload));
  Epoch := toInteger(Obj.Properties['exp']);
  Result := TJSDate.New(Epoch * 1000);
end;

class function TJwtHelper.TokenExpired(AToken: string): Boolean;
begin
  if not HasExpirationDate(AToken) then
    Exit(False);
  Result := TJSDate.now > toInteger(TokenExpirationDate(AToken).valueOf);
end;

end.
